import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  formatarDataHora,
  formatarParaInputDateTimeLocal,
} from "@/utils/FormatarEntradas";

dayjs.extend(utc);
dayjs.extend(timezone);

export function useValidacaoEncontros() {
  const criarEncontroPadrao = () => ({
    titulo: "",
    descricao: "",
    inicio_periodo: "",
    duracaoHoras: 0,
    duracaoMinutos: 0,
  });

  const temEdicaoPendente = (encontro) => {
    if (!encontro) return false;
    return Boolean(
      encontro.titulo ||
      encontro.descricao ||
      encontro.inicio_periodo ||
      Number(encontro.duracaoHoras) > 0 ||
      Number(encontro.duracaoMinutos) > 0
    );
  };

  const extrairDuracaoEncontro = (encontro) => {
    if (!encontro) {
      return { duracaoHoras: 0, duracaoMinutos: 0, duracao: "00:00" };
    }

    let duracaoHoras = 0;
    let duracaoMinutos = 0;

    if (
      (encontro.duracaoHoras !== undefined &&
        encontro.duracaoHoras !== null &&
        Number(encontro.duracaoHoras) > 0) ||
      (encontro.duracaoMinutos !== undefined &&
        encontro.duracaoMinutos !== null &&
        Number(encontro.duracaoMinutos) > 0)
    ) {
      duracaoHoras = Number(encontro.duracaoHoras) || 0;
      duracaoMinutos = Number(encontro.duracaoMinutos) || 0;
    } else if (
      encontro.duracao &&
      encontro.duracao !== "00:00" &&
      typeof encontro.duracao === "string" &&
      encontro.duracao.includes(":")
    ) {
      const [h, m] = encontro.duracao.split(":").map(Number);
      duracaoHoras = !isNaN(h) ? h : 0;
      duracaoMinutos = !isNaN(m) ? m : 0;
    } else if (encontro.inicio_periodo && encontro.fim_periodo) {
      const dataInicio = new Date(encontro.inicio_periodo);
      const dataFim = new Date(encontro.fim_periodo);
      const diffMs = dataFim.getTime() - dataInicio.getTime();
      if (!isNaN(diffMs) && diffMs > 0) {
        const minutosTotais = Math.floor(diffMs / (1000 * 60));
        duracaoHoras = Math.floor(minutosTotais / 60);
        duracaoMinutos = minutosTotais % 60;
      }
    }

    const duracao = `${String(duracaoHoras).padStart(2, "0")}:${String(
      duracaoMinutos
    ).padStart(2, "0")}`;

    return { duracaoHoras, duracaoMinutos, duracao };
  };

  const calcularFimPeriodo = (inicioPeriodo, duracaoHoras, duracaoMinutos) => {
    if (!inicioPeriodo) return "";
    const horas = Number(duracaoHoras) || 0;
    const minutos = Number(duracaoMinutos) || 0;
    return dayjs(inicioPeriodo)
      .add(horas, "hour")
      .add(minutos, "minute")
      .format("YYYY-MM-DDTHH:mm");
  };

  const formatarEncontro = (e) => {
    if (!e) return e;
    const { duracaoHoras, duracaoMinutos, duracao } = extrairDuracaoEncontro(e);
    const inicioFormatado = formatarParaInputDateTimeLocal(e.inicio_periodo);
    const fimFormatado = e.fim_periodo
      ? formatarParaInputDateTimeLocal(e.fim_periodo)
      : "";

    return {
      ...e,
      inicio_periodo: inicioFormatado || e.inicio_periodo || "",
      fim_periodo: fimFormatado || e.fim_periodo || "",
      duracaoHoras,
      duracaoMinutos,
      duracao,
    };
  };

  const toUTC = (date) => {
    if (!date) return null;
    return dayjs(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  };

  const formatarEncontroParaEnvio = (e) => {
    if (!e) return e;
    return {
      ...e,
      inicio_periodo: toUTC(e.inicio_periodo),
      fim_periodo: toUTC(e.fim_periodo),
    };
  };

  const validarDuracao = (duracaoHoras, duracaoMinutos) => {
    const horas = Number(duracaoHoras) || 0;
    const minutos = Number(duracaoMinutos) || 0;
    if (horas === 0 && minutos === 0) {
      return {
        valido: false,
        mensagem: "Informe a duração do encontro (horas ou minutos).",
      };
    }
    return { valido: true };
  };

  const validarDatasEncontros = (encontros, dataFimInscricao) => {
    if (!dataFimInscricao || dataFimInscricao === "") {
      return { valido: true };
    }

    const dataFim = dayjs(dataFimInscricao);
    const encontrosInvalidos = (encontros || []).filter((encontro) =>
      dayjs(encontro.inicio_periodo).isBefore(dataFim, "minute")
    );

    if (encontrosInvalidos.length > 0) {
      const listaTitulos = encontrosInvalidos
        .map(
          (e) =>
            `"${e.titulo || "Sem título"}" (${formatarDataHora(e.inicio_periodo)})`
        )
        .join(", ");

      return {
        valido: false,
        mensagem: `A data de início do encontro não pode ser anterior à data de fim das inscrições da atividade (${formatarDataHora(dataFimInscricao)}).\nEncontro(s) inválido(s): ${listaTitulos}.`,
        encontrosInvalidos,
      };
    }

    return { valido: true };
  };

  const calcularDataMinima = (dataFimInscricao) => {
    const agoraFormatado = dayjs().format("YYYY-MM-DDTHH:mm");
    if (dataFimInscricao && dataFimInscricao !== "") {
      const fimInscricaoFormatado =
        formatarParaInputDateTimeLocal(dataFimInscricao) || dataFimInscricao;
      if (dayjs(fimInscricaoFormatado).isAfter(dayjs(agoraFormatado))) {
        return fimInscricaoFormatado;
      }
    }
    return agoraFormatado;
  };

  return {
    criarEncontroPadrao,
    temEdicaoPendente,
    extrairDuracaoEncontro,
    calcularFimPeriodo,
    formatarEncontro,
    toUTC,
    formatarEncontroParaEnvio,
    validarDuracao,
    validarDatasEncontros,
    calcularDataMinima,
  };
}
